<template>
  <div class="border-2 px-3 py-4 radius-20 border-spect-gray overflow-x-auto">
    <DataTable
      :value="isLoading ? servicesSkeleton : services"
      :stripedRows="true"
      :paginator="true"
      :rows="10"
      :rowsPerPageOptions="[5, 10, 20]"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="{first} à {last} sur {totalRecords}"
      class="p-datatable-sm"
    >
      <Column field="name" :header="$t('user_manage.entitle')" sortable>
        <template #body="slotProps" v-if="!isLoading">
          <Tag :value="getServiceDisplayName(slotProps.data.name)" severity="secondary" />
        </template>
        <template #body v-else>
          <Skeleton></Skeleton>
        </template>
      </Column>

      <Column field="user_count" :header="$t('user_manage.user_count')" sortable>
        <template #body="slotProps" v-if="!isLoading">
          <div class="text-left">{{ slotProps.data.user_count || 0 }}</div>
        </template>
        <template #body v-else>
          <Skeleton></Skeleton>
        </template>
      </Column>

      <Column field="responsible" :header="$t('user_manage.responsible')" sortable>
        <template #body="slotProps" v-if="!isLoading">
          <span class="text-left">{{ getResponsibleLabel(slotProps.data) }}</span>
        </template>
        <template #body v-else>
          <Skeleton></Skeleton>
        </template>
      </Column>

      <Column field="created_at" :header="$t('user_manage.created_at')" sortable>
        <template #body="slotProps" v-if="!isLoading">
          {{ formatDate(slotProps.data.created_at) }}
        </template>
        <template #body v-else>
          <Skeleton></Skeleton>
        </template>
      </Column>

      <Column :header="$t('user_manage.actions')" style="width: 8rem">
        <template #body="slotProps" v-if="!isLoading">
          
          <div class="flex gap-1 justify-center">
            <Button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-text p-button-sm"
              @click="$emit('edit-service', slotProps.data)"
              v-tooltip="$t('user_manage.edit_service')"
            />
            <Button
              icon="pi pi-trash"
              class="p-button-rounded p-button-text p-button-danger p-button-sm"
              @click="$emit('delete-service', slotProps.data)"
              v-tooltip.left="$t('user_manage.delete_service')"
              :disabled="slotProps.index === 0"
            />
          </div>
        </template>
        <template #body v-else>
          <Skeleton></Skeleton>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Tag from 'primevue/tag'
import Button from 'primevue/button'
import Skeleton from 'primevue/skeleton'
import { useI18n } from 'vue-i18n'

useI18n()

defineProps({
  services: {
    type: Array,
    default: () => []
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  servicesSkeleton: {
    type: Array,
    default: () => new Array(5)
  }
})

defineEmits(['edit-service', 'delete-service'])

// Helper functions
const getServiceDisplayName = (name) => {
  if (!name) return ''
  // Split by underscore and take the first part
  return name.split('_')[0]
}

const getFullName = (user) => {
  if (!user) return '_'
  const first = user.firstname
  const last = user.lastname
  const name = [first, last].filter(Boolean).join(' ')
  return name || user.email || '_'
}

const getResponsibleLabel = (service) => {
  if (!service?.responsible) return '_'
  const ref = service.responsible
  if (typeof ref === 'object' && ref !== null) {
    return getFullName(ref)
  }
  const user = service.users?.find(u => u.id === ref)
  return getFullName(user) || '_'
}

const formatDate = (dateString) => {
  if (!dateString) return '-'
  return new Date(dateString).toLocaleDateString()
}
</script>